import React, { useEffect } from 'react';

// When the component is rendered add the recaptcha class to the page body
// This triggers our scss to display the recaptcha badge on the page
// as required by Google
// Remove the class to hide it when form is unmounted
function useShowReCaptchaBadge() {
  useEffect(() => {
    document.body.classList.add('recaptcha');
    return () => {
      document.body.classList.remove('recaptcha');
    };
  }, []);
}

export default useShowReCaptchaBadge;
